import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { HiOutlineSearch } from 'react-icons/hi';
import { useHistory, useRouteMatch } from 'react-router-dom';

import Button from 'partial/components/Button';
import FormInlineInput from 'partial/form/FormInlineInput';
import FormInlineSelect from 'partial/form/FormInlineSelect';

function CashbackFilters({ onSubmit, value }) {
  const history = useHistory();
  const match = useRouteMatch();
  const [form, setForm] = useState(value);
  const handleOnSubmit = useCallback(() => {
    onSubmit(form);
  }, [form, onSubmit]);
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center space-x-3">
        <FormInlineInput
          name="q"
          onChange={setForm}
          value={form?.q ?? ''}
          icon={HiOutlineSearch}
          placeholder="Search..."
        />
        <div className="w-48">
          <FormInlineSelect
            name="status"
            label="Status"
            onChange={setForm}
            value={form?.status ?? ''}
            options={[
              {
                label: 'All',
                value: '',
              },
              {
                label: 'Active',
                value: 'ACTIVE',
              },
              {
                label: 'Inactive',
                value: 'INACTIVE',
              },
            ]}
          />
        </div>
        <div className="w-48">
          <FormInlineSelect
            name="amount_type"
            label="Type"
            onChange={setForm}
            value={form?.amount_type ?? ''}
            options={[
              {
                label: 'All',
                value: '',
              },
              {
                label: 'BND',
                value: 'BND',
              },
              {
                label: 'Percentage',
                value: 'PERCENTAGE',
              },
            ]}
          />
        </div>
      </div>
      <div className="flex space-x-2">
        <Button type="submit" outlinePrimary onClick={handleOnSubmit}>
          Filter Selection
        </Button>
        <Button
          type="button"
          primary
          onClick={() => history.push(`${match.url}/add`)}
        >
          Add Cashback
        </Button>
      </div>
    </div>
  );
}

CashbackFilters.propTypes = {
  onSubmit: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.instanceOf(Object).isRequired,
};

export default CashbackFilters;
